import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarMinimizer,
  CSidebarNavItem,
  CSidebarNavDropdown,
} from "@coreui/react";

//import CIcon from '@coreui/icons-react';

import {
  minimizeDashboard,
  showDashboard,
} from "../../redux/actions/dashboard";
import { RootState } from "../../store";

// sidebar nav config
import { getRouteName, getRoutePath } from "../../routes";
import PermissionRequiredComponent from "../permissions/PermissionRequiredComponent";
import {
  ASSETS_RETRIEVE,
  COMPANIES_ADDITIONAL_FIELDS_UPDATE,
  DOCUMENT_VERIFICATIONS_RETRIEVE,
  DOCUMENTS_RETRIEVE,
  EMAIL_GROUPS_RETRIEVE,
  USERS_RETRIEVE,
} from "../../auth/permissions";

const Sidebar = () => {
  const dispatch = useDispatch();
  const show = useSelector((state: RootState) => state.dashboard.sidebarShow);
  const minimize = useSelector(
    (state: RootState) => state.dashboard.sidebarMinimize
  );

  const isAssetNavPage = () => {
    return (
      window.location.pathname === getRoutePath("assetSubtypes") ||
      window.location.pathname === getRoutePath("assetTypes") ||
      window.location.pathname === getRoutePath("assets") ||
      window.location.pathname === getRoutePath("assetTree")
    );
  };

  const isDocumentNavPage = () => {
    return (
      window.location.pathname === getRoutePath("documentCategories") ||
      window.location.pathname === getRoutePath("documentSubcategories") ||
      window.location.pathname === getRoutePath("tags") ||
      window.location.pathname === getRoutePath("documents") ||
      window.location.pathname === getRoutePath("barcodePrint") ||
      window.location.pathname === getRoutePath("documentsSpreadsheet")
    );
  };

  const [showAssetNav, setShowAssetNav] = useState(isAssetNavPage());
  const [showDocumentNav, setShowDocumentNav] = useState(isDocumentNavPage());

  const history = useHistory();

  useEffect(() => {
    return history.listen((_) => {
      setShowAssetNav(isAssetNavPage());
      setShowDocumentNav(isDocumentNavPage());
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return (
    <CSidebar
      show={show}
      onShowChange={(val: boolean) => {
        dispatch(showDashboard(val));
        window.localStorage.setItem("sidebarShow", val ? "true" : "false");
      }}
      minimize={minimize}
      onMinimizeChange={(val: boolean) => {
        dispatch(minimizeDashboard(!val));
        window.localStorage.setItem("sidebarMinimize", !val ? "true" : "false");
      }}
      dropdownMode={"noAction"}
    >
      <CSidebarBrand className="d-md-down-none" to="/"></CSidebarBrand>
      <CSidebarNav>
        <CSidebarNavItem
          name={getRouteName("dashboard")}
          to={getRoutePath("dashboard")}
          icon={"cil-home"}
        ></CSidebarNavItem>
        <PermissionRequiredComponent permissionName={DOCUMENTS_RETRIEVE}>
          <CSidebarNavItem
            name={getRouteName("subcompanies")}
            to={getRoutePath("subcompanies")}
            icon={<i className="c-sidebar-nav-icon fa fa-building"></i>}
          ></CSidebarNavItem>
        </PermissionRequiredComponent>
        <PermissionRequiredComponent
          permissionName={COMPANIES_ADDITIONAL_FIELDS_UPDATE}
        >
          <CSidebarNavItem
            name={getRouteName("companyAdditionalFields")}
            to={getRoutePath("companyAdditionalFields")}
            icon={<i className="c-sidebar-nav-icon fa fa-sliders"></i>}
          ></CSidebarNavItem>
        </PermissionRequiredComponent>
        <PermissionRequiredComponent permissionName={ASSETS_RETRIEVE}>
          <CSidebarNavDropdown
            name="Sección Productores"
            icon={<i className="c-sidebar-nav-icon fa fa-star"></i>}
            show={showAssetNav}
          >
            <CSidebarNavItem
              name={getRouteName("assets")}
              to={getRoutePath("assets")}
              icon={<i className="c-sidebar-nav-icon fa fa-bolt"></i>}
            ></CSidebarNavItem>
            <CSidebarNavItem
              name={getRouteName("assetTree")}
              to={getRoutePath("assetTree") || "/assets_tree/"}
              icon={<i className="c-sidebar-nav-icon fa fa-folder-tree"></i>}
            ></CSidebarNavItem>
            <CSidebarNavItem
              name={getRouteName("assetTypes")}
              to={getRoutePath("assetTypes")}
              icon={<i className="c-sidebar-nav-icon fa fa-shapes"></i>}
            ></CSidebarNavItem>
            <CSidebarNavItem
              name={getRouteName("assetSubtypes")}
              to={getRoutePath("assetSubtypes")}
              icon={<i className="c-sidebar-nav-icon fa fa-cubes-stacked"></i>}
            ></CSidebarNavItem>
          </CSidebarNavDropdown>
        </PermissionRequiredComponent>
        <PermissionRequiredComponent permissionName={DOCUMENTS_RETRIEVE}>
          <CSidebarNavDropdown
            name="Sección Documentos"
            icon={<i className="c-sidebar-nav-icon fa fa-box-archive"></i>}
            show={showDocumentNav}
          >
            <CSidebarNavItem
              name={getRouteName("documents")}
              to={getRoutePath("documents")}
              icon={<i className="c-sidebar-nav-icon fa fa-file"></i>}
            ></CSidebarNavItem>
            <CSidebarNavItem
              name={getRouteName("documentsSpreadsheet")}
              to={getRoutePath("documentsSpreadsheet")}
              icon={<i className="c-sidebar-nav-icon fa fa-file"></i>}
            ></CSidebarNavItem>
            <CSidebarNavItem
              name={getRouteName("barcodePrint")}
              to={getRoutePath("barcodePrint")}
              icon={<i className="c-sidebar-nav-icon fa fa-barcode"></i>}
            ></CSidebarNavItem>
            <CSidebarNavItem
              name={getRouteName("documentCategories")}
              to={getRoutePath("documentCategories")}
              icon={<i className="c-sidebar-nav-icon fa fa-folder"></i>}
            ></CSidebarNavItem>
            <CSidebarNavItem
              name={getRouteName("documentSubcategories")}
              to={getRoutePath("documentSubcategories")}
              icon={<i className="c-sidebar-nav-icon fa fa-folder-tree"></i>}
            ></CSidebarNavItem>
            <CSidebarNavItem
              name={getRouteName("tags")}
              to={getRoutePath("tags")}
              icon={<i className="c-sidebar-nav-icon fa fa-tag"></i>}
            ></CSidebarNavItem>
          </CSidebarNavDropdown>
        </PermissionRequiredComponent>
        <PermissionRequiredComponent
          permissionName={DOCUMENT_VERIFICATIONS_RETRIEVE}
        >
          <CSidebarNavItem
            name={getRouteName("documentVerifications")}
            to={getRoutePath("documentVerifications")}
            icon={<i className="c-sidebar-nav-icon fa fa-check"></i>}
          ></CSidebarNavItem>
        </PermissionRequiredComponent>
        <PermissionRequiredComponent permissionName={EMAIL_GROUPS_RETRIEVE}>
          <CSidebarNavItem
            name={getRouteName("emailGroups")}
            to={getRoutePath("emailGroups")}
            icon={<i className="c-sidebar-nav-icon fa fa-envelope"></i>}
          ></CSidebarNavItem>
        </PermissionRequiredComponent>

        <PermissionRequiredComponent permissionName={USERS_RETRIEVE}>
          <CSidebarNavItem
            name={getRouteName("users")}
            to={getRoutePath("users")}
            icon={"cil-people"}
          ></CSidebarNavItem>
        </PermissionRequiredComponent>
        <PermissionRequiredComponent permissionName={USERS_RETRIEVE}>
          <CSidebarNavItem
            name={getRouteName("audit")}
            to={getRoutePath("audit")}
            icon={<i className="c-sidebar-nav-icon fa fa-clipboard-list"></i>}
          ></CSidebarNavItem>
        </PermissionRequiredComponent>
      </CSidebarNav>
      <CSidebarMinimizer className="c-d-md-down-none" />
    </CSidebar>
  );
};

export default Sidebar;
